const feed = document.getElementById('festival-activity-feed');

if (!feed) {
    // Not on a festival page.
} else {
    const endpoint = feed.dataset.endpoint;

    const banner = document.getElementById(
        'festival-activity-feed-banner'
    );

    const items = document.getElementById(
        'festival-activity-feed-items'
    );

    const refreshButton = document.getElementById(
        'festival-activity-feed-refresh'
    );

    let newestTimestamp =
        feed.dataset.lastGenerated ?? '';

    let refreshAvailable = false;
    let pendingHtml = null;
    let pendingTimestamp = null;

    async function refreshFeed() {
        if (pendingHtml !== null) {
            items.innerHTML = pendingHtml;

            newestTimestamp = pendingTimestamp;

            pendingHtml = null;
            pendingTimestamp = null;

            refreshAvailable = false;

            banner.classList.add('hidden');

            return;
        }
        try {
            const response = await fetch(endpoint, {
                headers: {
                    Accept: 'application/json',
                },
                credentials: 'same-origin',
            });

            if (!response.ok) {
                return;
            }

            const data = await response.json();

            items.innerHTML = data.html;

            newestTimestamp = data.generated_at;

            pendingHtml = null;
            pendingTimestamp = null;

            refreshAvailable = false;

            banner.classList.add('hidden');
        } catch (error) {
            console.error(
                'Unable to refresh activity feed.',
                error
            );
        }
    }

    async function checkForUpdates() {
        if (refreshAvailable) {
            return;
        }

        try {
            const response = await fetch(endpoint, {
                headers: {
                    Accept: 'application/json',
                },
                credentials: 'same-origin',
            });

            if (!response.ok) {
                return;
            }

            const data = await response.json();

            if (
                data.generated_at &&
                data.generated_at !== newestTimestamp
            ) {
                pendingHtml = data.html;

                pendingTimestamp = data.generated_at;

                refreshAvailable = true;

                banner.classList.remove('hidden');
            }
        } catch (error) {
            console.error(
                'Unable to check activity feed.',
                error
            );
        }
    }

    refreshButton.addEventListener(
        'click',
        () => {
            refreshFeed();
        }
    );

    setInterval(checkForUpdates, 30000);
}